
import { defineComponent } from '@nuxtjs/composition-api';
import type { Location } from 'vue-router';
import HeaderAnonymousProfileSkeleton from './HeaderAnonymousProfileSkeleton.vue';
import { WAR_ROOM_PROFILE_EDIT_PAGE, WAR_ROOM_PROFILE_USERNAME_PAGE } from '@/constants/pages_generated';
import type { CurrentUser } from '@/types/graphql';
import Avatar from '~/components/common/Avatar/Avatar.vue';

export default defineComponent({
  name: 'HeaderAnonymousProfile',
  components: {
    EyeSlashIcon: () => import('@/assets/svg/eye-slash.vue.svg'),
    HeaderAnonymousProfileSkeleton,
    Avatar,
  },
  props: {
    currentUser: {
      type: Object as () => CurrentUser | null,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasWarRoomProfile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    username(): string {
      return this.hasWarRoomProfile ? `@${this.currentUser?.username}` || '' : 'Anonymous profile';
    },
    initials(): string {
      return this.currentUser?.username?.substring(0, 1)?.toLocaleUpperCase() || '';
    },
    link(): Location {
      return this.hasWarRoomProfile
        ? { ...WAR_ROOM_PROFILE_USERNAME_PAGE, params: { username: this.currentUser?.username ?? '' } }
        : WAR_ROOM_PROFILE_EDIT_PAGE;
    },
    position(): string {
      return this.currentUser?.warRoomPosition || '';
    },
  },
});
